import { IApplicationState } from '../../types/redux';

export function getIsFlatTourAvailable(state: IApplicationState): boolean {
  return Boolean(state.flatTourBooking);
}
